/* eslint-disable no-nested-ternary */
import React from 'react';

import { format } from 'date-fns';
import PullToRefresh from 'react-simple-pull-to-refresh';

import history from 'utils/history';
import numberToReal from 'utils/numberToReal';
import { shortenString } from 'utils/shortenString';

import SkeletonLoading from './SkeletonLoading';
import { CardReceiver, MobileReceiver } from './style';
import { providerNameValidation } from 'utils/providerNameValidation';
import { addHours, getDay, isBefore, startOfToday } from 'date-fns';


function MobileRecebimento({ data, getId, loading, inputKey }) {
  function handleDetails(receiverId) {
    history.push(`/recebimento/${getId}/${receiverId}`);
  }

  function backgroundColorStatus(status, dlvrDate, receipt) {
    const { orderItems } = receipt

    const inProgress = () => {
      if (receipt?.status.toUpperCase() === 'IN PROGRESS' && isBefore(addHours(new Date(receipt.deliveryDate), 3), startOfToday())) {
        if (orderItems?.some(el => el?.sku?.status === "RECEIVED") && !orderItems.every(el => el?.sku?.status === "RECEIVED")) {
          return '#08AA15'
        }
        return '#AA8208'
      }
      
      if (receipt.status.toUpperCase() === 'IN PROGRESS' && (receipt.statusPaymentDocument.toUpperCase() === 'PENDING' || receipt.statusPaymentDocument.toUpperCase() === 'VALIDATE')) {
        return '#5062F0'
      }
    }

    if (status.toUpperCase() === 'IN PROGRESS') {
      return inProgress()
    }

    if (status.toUpperCase() === 'RECEIVED') {
      return '#D2F9D6';
    }

    if (
      status.toUpperCase() === 'RETURNED'
    ) {
      return '#660008';
    }

    if (
      status.toUpperCase() === 'NOT RECEIVED'
    ) {
      return '#F53D4C';
    }

    if (status.toUpperCase() === 'PENDING') {
      return '#d3d3d3';
    }
  }

  function wordColorStatus(status, dlvrDate, receipt) {
    const { orderItems } = receipt

    const inProgress = () => {
      if (receipt?.status.toUpperCase() === 'IN PROGRESS' && isBefore(addHours(new Date(receipt.deliveryDate), 3), startOfToday())) {
        if (orderItems?.some(el => el?.sku?.status === "RECEIVED") && !orderItems.every(el => el?.sku?.status === "RECEIVED")) {
          return '#08AA15'
        }
        return '#AA8208'
      }
      
      if (receipt.status.toUpperCase() === 'IN PROGRESS' && (receipt.statusPaymentDocument.toUpperCase() === 'PENDING' || receipt.statusPaymentDocument.toUpperCase() === 'VALIDATE')) {
        return '#5062F0'
      }
    }

    if (status.toUpperCase() === 'IN PROGRESS') {
      return inProgress()
      
    }

    if (status.toUpperCase() === 'RECEIVED') {
      return '#08AA15';
    }

    if (
      status.toUpperCase() === 'RETURNED'
    ) {
      return '#AA0816';
    }

    if (
      status.toUpperCase() === 'NOT RECEIVED'
    ) {
      return '#F53D4C';
    }

    if (status.toUpperCase() === 'PENDING') {
      return '#0B1A8E';
    }
  }

  function handleTranslateStatus(status, dlvrDate, orderDate, receipt) {
    const { orderItems } = receipt

    const inProgress = () => {
      if (receipt?.status.toUpperCase() === 'IN PROGRESS' && isBefore(addHours(new Date(receipt.deliveryDate), 3), startOfToday())) {
        if (orderItems?.some(el => el?.sku?.status === "RECEIVED") && !orderItems.every(el => el?.sku?.status === "RECEIVED")) {
          return 'Recebido parcialmente'
        }
        return 'Atrasado'
      }
      
      if (receipt.status.toUpperCase() === 'IN PROGRESS' && (receipt.statusPaymentDocument.toUpperCase() === 'PENDING' || receipt.statusPaymentDocument.toUpperCase() === 'VALIDATE')) {
        return 'Andamento'
      }
    }

    const stts = {
      RECEIVED: 'Recebido',
      'IN PROGRESS': inProgress(),
      RETURNED: 'Devolvido',
      'NOT RECEIVED': 'Não Recebido',
      PENDING: 'Aprovação'
    };
    return stts[status];
  }

  function backgroundColorNf(status) {
    if (status?.toUpperCase() === 'VALIDATE') {
      return '#D2F9D6';
    }
    return '#FFF2CC';
  }

  function wordColorNf(status) {
    if (status?.toUpperCase() === 'VALIDATE') {
      return '#08AA15';
    }
    return '#AA8208';
  }

  const skeletonArray = [];

  return (
    <PullToRefresh
      className="customPullToRefresh"
      onRefresh={() => window.location.reload()}
    >
      <MobileReceiver>
        {loading && <SkeletonLoading skeletonArray={skeletonArray} />}

        {data.map((dataRecebimento) => {
          const total = dataRecebimento.orderItems.reduce(
            (total, valor) =>
              valor.itemsPaymentDocument
                ? parseFloat(total) + parseFloat(valor.itemsPaymentDocument.total)
                : total + 0,
            0
          );

          const nfsReceived = [];
          const nfsUnique = [];

          const nfsCountItemsReceived = dataRecebimento.orderItems.filter(
            (order) => order?.sku?.status === 'RECEIVED'
          );
          nfsCountItemsReceived.map((items) => {
            if (
              items.itemsPaymentDocument &&
              nfsReceived.indexOf(
                items.itemsPaymentDocument.paymentDocumentNumber !== -1
              )
            ) {
              nfsReceived.push(
                items.itemsPaymentDocument.paymentDocumentNumber
              );
            }
          });

          // função que exibe as notas fiscais únicas recebidas por pedido
          const setNFSUniqueReceived = new Set(nfsReceived);

          dataRecebimento.orderItems.map((items) => {
            if (
              items.itemsPaymentDocument &&
              nfsUnique.indexOf(
                items.itemsPaymentDocument.paymentDocumentNumber !== -1
              )
            ) {
              nfsUnique.push(
                items.itemsPaymentDocument.paymentDocumentNumber
              );
            }
          });

          // função que exibe quantidade de notas fiscais únicas por pedido
          const setNFS = new Set(nfsUnique);

          return (
            // eslint-disable-next-line no-underscore-dangle
            <CardReceiver 
              onClick={() => handleDetails(dataRecebimento._id)}
            >
              <div className='nfAndData'>
                <p className='pl8 pt4 m0'>
                  NF{' '}
                  {shortenString(
                    dataRecebimento?.orderItems[0]?.itemsPaymentDocument
                      ?.paymentDocumentNumber,
                    8
                  )}
                  <span>
                  {`${[...setNFSUniqueReceived]?.length}/${[...setNFS]?.length
                              }`}
                  </span>
                </p>
                <p className='pr8 pt4 bold m0'>
                {format(
                    new Date(dataRecebimento.deliveryDate).valueOf() + 10800000,
                    'dd/MM/yy '
                  )}
                </p>
              </div>
              <div className='nameSpace'>
                <p>                                  
                  {providerNameValidation(dataRecebimento)}
                </p>
              </div>
              <div className='statusValue'>
                <div
                    style={{
                      border: `1px solid ${backgroundColorStatus(
                        dataRecebimento.status,
                        dataRecebimento.deliveryDate,
                        dataRecebimento
                      )}`,
                      color: wordColorStatus(
                        dataRecebimento.status,
                        dataRecebimento.deliveryDate,
                        dataRecebimento
                      ),
                      minWidth:'168px'
                    }}
                    className='justifyCenter dFlex statusBox'
                  >
                  {handleTranslateStatus(
                    dataRecebimento.status,
                    dataRecebimento.deliveryDate,
                    dataRecebimento.orderDate,
                    dataRecebimento
                  )}
                </div>

                <p>
                  R${numberToReal(total, 2)}
                </p>
              </div>
              {/* <div className="nameAndStatus">
                <p>{shortenString(dataRecebimento.providerName, 25)}</p>

                <div
                  style={{
                    backgroundColor: backgroundColorStatus(
                      dataRecebimento.status,
                      dataRecebimento.deliveryDate,
                      dataRecebimento.orderDate
                    ),
                    color: wordColorStatus(
                      dataRecebimento.status,
                      dataRecebimento.deliveryDate,
                      dataRecebimento.orderDate
                    )
                  }}
                >
                  {handleTranslateStatus(
                    dataRecebimento.status,
                    dataRecebimento.deliveryDate,
                    dataRecebimento.orderDate
                  )}
                </div>
              </div>

              <div className="description">
                <div
                  style={{
                    backgroundColor: backgroundColorNf(
                      dataRecebimento.statusPaymentDocument
                    ),
                    color: wordColorNf(dataRecebimento.statusPaymentDocument),
                    width: '150px'
                  }}
                >
                  {' '}
                  <p>
                    NF{' '}
                    {shortenString(
                      dataRecebimento?.orderItems[0]?.itemsPaymentDocument
                        ?.paymentDocumentNumber,
                      8
                    )}
                  </p>{' '}

                  <p>
                    {dataRecebimento.statusPaymentDocument === 'VALIDATE'
                      ? 'validado'
                      : 'não validado'}
                  </p>
                </div>

                <div
                  style={{
                    backgroundColor: 'transparent',
                    color: 'black',
                    fontSize: '12px',
                    margin: '0 4px'
                  }}
                >
                  {' '}
                  {format(
                    new Date(dataRecebimento.deliveryDate).valueOf() + 10800000,
                    'dd/MM'
                  )}
                </div>

                <p>
                  R${numberToReal(total)}
                </p>
              </div> */}
            </CardReceiver>
          )
        })}

        {inputKey ?
          <span className="w100">
            {inputKey}
          </span>
        : null}
      </MobileReceiver>
    </PullToRefresh>
  );
}

export default MobileRecebimento;
